import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getFunctions } from 'firebase/functions';
import { getStorage } from 'firebase/storage';

const firebaseDevConfig = {
    apiKey: "AIzaSyDQ1YPb79LkPTCV5cWll1d4PDPD-lYutgI",
    authDomain: "organics-electronics.firebaseapp.com",
    projectId: "organics-electronics",
    storageBucket: "organics-electronics.firebasestorage.app",
    messagingSenderId: "825916261281",
    appId: "1:825916261281:web:abfe56ba01678cf6e3c1e0"
};

const firebaseProdConfig = {
    apiKey: "AIzaSyBqqcRpqyRoNdI8LOV_-yq_0s-l83wVS0A",
    authDomain: "organics-electronics-prod.firebaseapp.com",
    projectId: "organics-electronics-prod",
    storageBucket: "organics-electronics-prod.firebasestorage.app",
    messagingSenderId: "169867705448",
    appId: "1:169867705448:web:d22f625b3ae6bb46154fdd"
};

// Select config based on REACT_APP_ENV
const firebaseConfig = process.env.REACT_APP_ENV === 'production'
    ? firebaseProdConfig
    : firebaseDevConfig;

// Determine which environment is being used
const isProduction = firebaseConfig.projectId === 'organics-electronics-prod';
const isDevelopment = firebaseConfig.projectId === 'organics-electronics';

// Log current environment (only in development mode)
if (process.env.NODE_ENV === 'development') {
    console.log(`🔥 Firebase Environment: ${isProduction ? 'PRODUCTION' : isDevelopment ? 'DEVELOPMENT' : 'UNKNOWN'}`);
    console.log(`📦 Project ID: ${firebaseConfig.projectId}`);
    console.log(`🔧 REACT_APP_ENV: ${process.env.REACT_APP_ENV || 'not set (defaulting to development)'}`);
}

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const firestore = getFirestore(app);
export const functions = getFunctions(app);
export const storage = getStorage(app);
export const storageBucketName = firebaseConfig.storageBucket;

//connectFunctionsEmulator(functions, "localhost", 5001);

export const createCustomTokenFunctionUrl = isProduction ? 'https://createcustomtokenhttp-7fsmwlyjmq-uc.a.run.app' : 'https://createcustomtokenhttp-na5fnt3x3a-uc.a.run.app';

// Export environment info
export const firebaseEnv = {
    isProduction,
    isDevelopment,
    projectId: firebaseConfig.projectId,
    environment: isProduction ? 'production' : isDevelopment ? 'development' : 'unknown'
};

export default app;
